import { toast } from "react-toastify";
import React, { useEffect, useState, useRef } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import { Tab, Tabs } from "react-bootstrap";
import { UserHelper } from "@/app/core/util/helpers/UserHelper";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import { CnpjMask, OnDataChange } from "@/app/core/util/helpers/FieldHelper";
import { FileController } from "@/app/core/base/controllers/FileController";
import Field from "@/app/core/layouts/main-components/input/Field";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import { TimelineController } from "@/app/core/base/controllers/TimelineController";
import Storage from "@/app/core/util/Storage";
import SelectCompanyModal from "@/app/core/layouts/main-components/companies/SelectCompanyModal";
import { ServicesController } from "@/app/core/base/controllers/ServicesController";

export default function ComplainEditModal({ show, onHide, infos }) {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState({});
    const [userData, setUserData] = useState(Storage.getUserData());
    const [timeline, setTimeline] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);


    useEffect(() => {
        console.log("informações", infos)
        if (show && infos && infos.id) {
            setData(infos);
            loadInfos()
            if (infos && infos.selectedServices) {
                loadSelectedServices(infos.selectedServices);
            }
        } else {
            setData({});
        }
    }, [show]);

    async function loadInfos() {
        const res = await TimelineController.List(infos.id);
        setTimeline(res);
    }

    async function loadSelectedServices(serviceIds) {
        const services = await ServicesController.ListSelectedServices(serviceIds);
        setSelectedServices(services);
    }

    async function save() {
        TimelineController.Insert({
            description: `${userData.name} alterou os dados da reclamação`,
            complainId: data.id,
        });

        await ComplainController.Update(data);
        onHide();
    }

    async function saveNewCompany(company){
        console.log("Empresa nova", company);
        let old = data;
        old.complainId = company.id;

        old.company = company;
        await ComplainController.Update(data);
    }

    function handleChange(evt, type) {
        setData(OnDataChange(data, evt, type))
    }

    return (
        <Modal
            title={`Reclamação - ${data && data.id}`}
            show={show}
            onHide={onHide}
            isLoading={loading}
            onSubmit={() => save()}
        >

            <Tabs
                defaultActiveKey="resumo"
                id="uncontrolled-tab-example"
                className="mb-3"
            >
                <Tab eventKey="resumo" title="Resumo" className="block-content">

                    <Field type={FieldTypeObj.Text} title={"Título"} name={"title"} value={data && data.title} onChange={evt => handleChange(evt)} />
                    <Field type={FieldTypeObj.TextArea} title={"Descrição"} name={"description"} value={data && data.description} onChange={evt => handleChange(evt)} />
                    <div className="row ml-1">
                        <span className="col-8 form-control">{data && data.company && data.company.name}</span>
                        <span className="col-4">
                            <button className="btn btn-square btn-info" onClick={()=> setShowModal(true)}><i className="far fa-edit" /> Editar empresa</button>
                        </span>

                    </div>
                </Tab>
                <Tab eventKey="services" title="Serviços Selecionados" className="block-content">
                    <div className="content-heading">
                        <h4 className="text-muted">Serviços Selecionados</h4>
                    </div>
                    <ul>
                        {selectedServices.map(service => (
                            <li key={service.id}>{service.name}</li>
                        ))}
                    </ul>
                </Tab>
                <Tab
                    eventKey="timeline"
                    title={`Timeline`}>
                    <div className="text-muted py-1">Timeline</div>
                    <ul class="timeline timeline-alt mt-0 mb-0" style={{ marginTop: -35 }}>
                        {timeline && timeline.map(item => (
                            <li className="timeline-event mt-2 mb-3">
                                <div class="media">
                                    <div className="mr-3 ml-3 overlay-container overlay-left">
                                        <span className="overlay-item item item-tiny item-circle border border-2x border-white bg-success"></span>
                                    </div>
                                    <div className="media-body ml-2">
                                        {item.description} <br />
                                        <small>
                                            <i className="si si-calendar mr-1" /> {item && DateTranslate(item.createdDate)}
                                        </small>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </Tab>
            </Tabs>
            <SelectCompanyModal
                show={showModal}
                report={company => saveNewCompany(company)}
                onHide={()=> setShowModal(false)}/>
        </Modal>
    );
}
